<div id="getstarted" class="dialog-page">
    <div class="dialog-container">
        <div layout="row" class="container">
            <div class="left">
                <div class="logo">
                    <a routerLink="/">
                        <img src="/assets/images/logo_white.svg" />
                    </a>
                </div>
                <h1>{{ "configuration_wizard.title" | translate }}</h1>
                <h2>{{ "configuration_wizard.text" | translate }}</h2>
            </div>

            <div class="right">
                <form [formGroup]="form" (ngSubmit)="save(form.value)">
                    <div class="fields">
                        <mat-form-field class="full-width">
                            <input
                                matInput
                                placeholder="{{
                                    'settings.user_settings.fields.name'
                                        | translate
                                }}"
                                formControlName="name"
                            />
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-select
                                placeholder="{{
                                    'settings.user_settings.fields.currency'
                                        | translate
                                }}"
                                formControlName="currency"
                            >
                                <mat-option
                                    [value]="code"
                                    *ngFor="let code of objectKeys(currencies)"
                                    >{{ currencies[code].name }} ({{
                                        currencies[code].symbol
                                    }})</mat-option
                                >
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-select
                                placeholder="{{
                                    'settings.user_settings.fields.numbering_system'
                                        | translate
                                }}"
                                formControlName="numberingSystem"
                            >
                                <mat-option value="fdi">FDI</mat-option>
                                <mat-option value="universal"
                                    >Universal (American)</mat-option
                                >
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-select
                                placeholder="{{
                                    'settings.user_settings.fields.language'
                                        | translate
                                }}"
                                formControlName="language"
                            >
                                <mat-option
                                    *ngFor="let language of supportedLanguages"
                                    [value]="language.locale"
                                >
                                    {{ language.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <file-drop
                            (onFileDrop)="dropped($event)"
                            (click)="fileInput.click()"
                        >
                            <div [hidden]="logoUrl">
                                <i
                                    class="fa fa-cloud-upload"
                                    aria-hidden="true"
                                ></i>
                                {{
                                    "settings.user_settings.upload_logo"
                                        | translate
                                }}
                            </div>
                            <img [src]="logoUrl" *ngIf="logoUrl" />
                        </file-drop>

                        <input
                            id="input-logo"
                            type="file"
                            accept="image/*"
                            #fileInput
                            [hidden]="true"
                            (change)="uploadLogo()"
                        />
                    </div>

                    <div class="actions">
                        <a [routerLink]="['/dashboard']">
                            {{ "skip" | translate }}
                        </a>
                        <button
                            mat-raised-button
                            color="primary"
                            type="submit"
                            [disabled]="!form.valid"
                            class="uppercase"
                        >
                            {{ "save" | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/settings/pages/configuration-wizard/configuration-wizard.component.html